module.exports = __webpack_public_path__ + "img/training-with-others.4822eddf.svg";